// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"417": "__federation_expose_1.0__KaleMonolith","548": "__federation_expose_1.0__HelloKale","782": "__federation_expose_1.0__KaleReviewLauncher","81": "__federation_expose_1.0__KaleBody","956": "__federation_expose_1.0__KaleEmbeddedApp",}[chunkId] || chunkId) + ".Beta." + __webpack_require__.h() + ".chunk.min.js"
}